import { LanguageCode } from '@language';
import { ApiThesaurusConcept, ThesaurusApiTranslation } from '@stylehaven/components';

export function GetApiThesaurusConceptLabel(concept: ApiThesaurusConcept, languageCode: LanguageCode): string | null {
    const lowerCaseLang: string = languageCode.toLowerCase();

    return (
        GetPreferredLabel(concept, lowerCaseLang)?.Label || GetAlternativeLabel(concept, lowerCaseLang)?.Label || null
    );
}

function GetPreferredLabel(concept: ApiThesaurusConcept, lowerCaseLang: string): ThesaurusApiTranslation | undefined {
    return concept.PreferredLabels.find(el => el.Lang === lowerCaseLang);
}

function GetAlternativeLabel(concept: ApiThesaurusConcept, lowerCaseLang: string): ThesaurusApiTranslation | undefined {
    return concept.AlternativeLabels.find(el => el.Lang === lowerCaseLang);
}
